import { connect } from "react-redux";
import TableComponent from "../../../Components/RecordingComponent/TableComponent/TableComponent";
const mapStateToProps = (state) => ({
    callFlows: state.reducer.callFlows,
    supervisedAgentDetails: state.reducer.supervisedAgentDetails,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableComponent);
